import * as msal from '@azure/msal-browser';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { default as React } from 'react';
import { FaCog } from 'react-icons/fa';
import { connect } from "react-redux";
import { Link, Redirect } from 'react-router-dom';
import environment from '../src/environments/environment';
import logo from './assets/images/logo.png';
import * as Config from './Config';
import * as constants from './Constants';

const mapStateToProps = state => {
    return {
        userStatus: state.lognReducer,
    }
}
class Header extends React.Component {
    constructor() {
        super();
        this.state = {
            reDirect: '',
            userName: '',
            userRole: '',
            email: '',
        }
        this.logout = this.logout.bind(this);
    };
    async componentDidMount() {
        this.setState({
            email: this.props.userStatus.emailId,
            userName: this.props.userStatus.userName,
            userRole: this.props.userStatus.userRole,
        }, () => {
            if (this.state.userRole === "Supervisor") {
                this.setState({
                    role: true,
                })
            } else {
                this.setState({
                    role: false,
                })
            }
        });

    }

    logout= e => {
        e.preventDefault();
        const msalConfig = {
            auth: {
                clientId: Config.clientId,
                authority: Config.authority,
                redirectUri: Config.redirectUri
            },
            cache: {
                cacheLocation: "localStorage", // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            }
        };
        const msalClient = new msal.PublicClientApplication(msalConfig);
        const accounts = msalClient.getAllAccounts();
        const logoutRequest = {
            account: msalClient.getAccountByUsername(this.state.email)
        }
        msalClient.logoutRedirect(logoutRequest);
        this.tologinHistory();
    }
    tologinHistory() {
        let loginHistoryVO = {};
        loginHistoryVO.id = 0;
        loginHistoryVO.name = this.state.userName;
        loginHistoryVO.emailId = this.props.userStatus.emailId;
        loginHistoryVO.action = constants.ACTION_LOGOUT;
        loginHistoryVO.actionDate = new Date();
        loginHistoryVO.isActive = constants.IS_ACTIVE_YES;
        loginHistoryVO.createdBy = this.props.userStatus.emailId;
        loginHistoryVO.lastUpdatedBy = this.props.userStatus.emailId;
        axios.post(environment.postLoginHistory, loginHistoryVO)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    //  toast.success(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
                } else {
                    //  toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
                }
            })
            .catch((error) => {
                //  toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
            });
    }

    static getDerivedStateFromProps(props, state) {
        if (props.userStatus.userName !== state.userName) {
            return {
                userName: props.userStatus.userName,
                userRole: props.userStatus.userRole,

            };
        }
        // Return null to indicate no change to state.
        return null;
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect to={this.state.reDirect} />
        }
        return (
            <div className="headerBox" height="100" >
                <nav className="navbar navbar-expand-sm navbar-light bg-faded">
                    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#nav-content"
                        aria-controls="nav-content" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <a className="navbar-brand  " style={{ paddingLeft: '5%' }}>
                        <img name="crt" src={logo} width="250" height="100" style={{ marginLeft: '0px' }} border="0" id="crt" alt="" />
                    </a>
                    <div className="collapse navbar-collapse flex-md-column ml-auto" id="nav-content" style={{ paddingRight: '35px' }}>
                        <ul className="navbar-nav ml-auto " style={{ marginRight: '87px' }}>
                            <li className="nav-item pr-0 pl-0 ">
                                <div className="col-md-12 ml-5 pl-0 " style={{ marginTop: '28px' }}>
                                    <h6 >Hi,&nbsp; {this.props.userStatus.userName}</h6>
                                </div>
                            </li>
                        </ul>
                        <div className="text-light input-group " style={{ textAlign: 'right', paddingRight: '8%' }}>
                            <ul className="navbar-nav nav-right mb-0" id="menu" style={{ marginRight: '0%' }}>
                                <li className="nav-item dropdown">
                                    <a className="nav-link  text-black  dropdown-toggle" id="reportDropdown"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >Cases</a>
                                    {this.state.userRole === 'Supervisor' || this.state.userRole === 'Admin' ? (<div className="dropdown-menu" aria-labelledby="reportDropdown">
                                        <Link className="nav-link link  text-black " to="/caseSummary"  >Cases</Link>
                                        <Link className="nav-link link  text-black " to="/newCase"  >New Case</Link>
                                        <Link className="nav-link link  text-black " to="/bulkCases"  >Bulk Case(s)</Link>
                                        <Link className="nav-link link  text-black " to="/transferCases"  >Transfer Case(s)</Link>

                                    </div>) : (<div className="dropdown-menu" aria-labelledby="reportDropdown">
                                        <Link className="nav-link link  text-black " to="/caseSummary"  >Cases</Link>
                                        <Link className="nav-link link  text-black disabled " to="/newCase"  >New Case</Link>
                                        <Link className="nav-link link  text-black disabled " to="/bulkCases"  >Bulk Case(s)</Link>
                                    </div>)}
                                </li>
                                <li className="nav-item dropdown">
                                    <a className="nav-link  text-black  dropdown-toggle" id="reportDropdown"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >Users</a>
                                    <div className="dropdown-menu" aria-labelledby="reportDropdown">
                                        {this.state.userRole === 'Supervisor' || this.state.userRole === 'Admin' ? (
                                            <Link className="nav-link link  text-black " to="./userSummary"  >Users</Link>) : (
                                            <Link className="nav-link link  text-black disabled " to="./userSummary"  >Users</Link>
                                        )}
                                    </div>
                                </li>
                                <li className="nav-item dropdown">
                                    <a className="nav-link  text-black  dropdown-toggle" id="reportDropdown"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >Reports</a>
                                    <div className="dropdown-menu" aria-labelledby="reportDropdown">
                                        {this.state.userRole === 'Supervisor' || this.state.userRole === 'Admin' ?
                                            (
                                                <div>
                                                    {environment.CaseMetricsMenuItemRequired && <Link className="nav-link link  text-black " to="./RunMetrics"  >Run Metrics</Link>}
                                                    <Link className="nav-link link  text-black " to="./ViewMetrics" >Case Metrics</Link>
                                                </div>) : (
                                                <div>
                                                    {environment.CaseMetricsMenuItemRequired && <Link className="nav-link link  text-black disabled" to="./RunMetrics"  >Run Metrics</Link>}
                                                    <Link className="nav-link link  text-black disabled" to="./ViewMetrics"  >Case Metrics</Link>
                                                </div>
                                            )}
                                    </div>
                                </li>
                                <li className="nav-item dropdown  ">
                                    <a href="#" className="nav-link dropdown-toggle pr-5 mr-1"
                                        id="adminDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <FaCog className="mr-1"></FaCog>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-center" aria-labelledby="adminDropdown">
                                        {/* <a href="" className="dropdown-item"
                                        >Settings</a> */}
                                        {this.state.userRole === 'Admin' && <Link className="nav-link link  text-black " to="./loginHistory" >Login History</Link>}
                                        {this.props.userStatus.loginIdentity === 'web' && <Link className="nav-link link  text-black " onClick={this.logout} to="./" >Sign Out</Link>}
                                        {/* <a href="" className="dropdown-item"
                                        >Sign Out</a> */}
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </nav>

            </div>
            //   <nav classNameName="navbar navbar-expand-sm  ">
            //        <img name="crt" src={thomasquinn} width="230" height="110" style={{ marginLeft: '60px' }} border="0" id="crt" alt="" />
            //   <ul classNameName="navbar-nav">
            //     <li classNameName="nav-item active">
            //       <a classNameName="nav-link" href="#">Active</a>
            //     </li>
            //     <li classNameName="nav-item">
            //       <a classNameName="nav-link" href="#">Link</a>
            //     </li>
            //     <li classNameName="nav-item">
            //       <a classNameName="nav-link" href="#">Link</a>
            //     </li>
            //     <li classNameName="nav-item">
            //       <a classNameName="nav-link " href="#">Disabled</a>
            //     </li>
            //   </ul>
            // </nav>

        )
    }
}
export default connect(mapStateToProps)(Header);